import SeverityPill from "./SeverityPill";

export default function FindingCard({ f, index }) {
  const s = (f.severity || "amber").toLowerCase();
  const borderColor =
    s === "red" ? "var(--severity-red-text)" : s === "green" ? "var(--severity-green-text)" : "var(--severity-amber-text)";
  return (
    <div
      data-testid={`finding-card-${index}`}
      className="paper-card fade-up"
      style={{ borderLeft: `3px solid ${borderColor}` }}
    >
      <div className="flex items-start justify-between gap-4">
        <h3 className="font-serif-display text-xl text-ink leading-tight" data-testid={`finding-title-${index}`}>
          {f.title}
        </h3>
        <SeverityPill severity={f.severity} testId={`finding-severity-${index}`} />
      </div>

      {f.quoted_snippet && (
        <div className="mt-4">
          <div className="eyebrow mb-2">
            Quoted from document
            {f.page_number ? ` · p.${f.page_number}` : ""}
          </div>
          <div className="quote-block" data-testid={`finding-quote-${index}`}>
            "{f.quoted_snippet}"
          </div>
        </div>
      )}

      {f.why_it_matters && (
        <div className="mt-4">
          <div className="eyebrow mb-1">Why it matters</div>
          <p className="text-sm text-ink-70 leading-relaxed" data-testid={`finding-why-${index}`}>
            {f.why_it_matters}
          </p>
        </div>
      )}

      {f.recommended_action && (
        <div className="mt-4">
          <div className="eyebrow mb-1">Recommended action</div>
          <p className="text-sm text-ink leading-relaxed" data-testid={`finding-action-${index}`}>
            {f.recommended_action}
          </p>
        </div>
      )}
    </div>
  );
}
